/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  commodity.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:29
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

const commodityRouter = [
  {
    path: '/commodity',
    name: 'Commodity',
    component: () =>
            import(/* webpackChunkName: "commodity" */ '@/views/goodsManage/commodity/index.vue'),
    meta: {
      title: '我的商品',
      keepAlive: true,
      deepth: 1,
      permission: true
    },
  },
  {
    path: '/addCommodity',
    name: 'AddCommodity',
    component: () =>
            import(/* webpackChunkName: "commodity" */ '@/views/goodsManage/commodity/addCommodity.vue'),
    meta: {
      title: '发布商品',
      // keepAlive: true,
      deepth: 1
    },
  },
  {
    path: '/addSuccess',
    name: 'AddSuccess',
    component: () =>
            import(/* webpackChunkName: "commodity" */ '@/views/goodsManage/commodity/subPage/addSuccess.vue'),
    meta: {
      title: '发布成功',
      // keepAlive: true,
      deepth: 1
    },
  },
  {
    path: '/searchCommodity',
    name: 'searchCommodity',
    component: () =>
            import(/* webpackChunkName: "commodity" */ '@/views/goodsManage/commodity/searchCommodity.vue'),
    meta: {
      title: '搜索历史',
      deepth: 1
    },
  },
  {
    path: '/commodsDetail',
    name: 'CommodsDetail',
    component: () =>
            import(/* webpackChunkName: "commodity" */ '@/views/goodsManage/commodity/commodsDetail.vue'),
    meta: {
      title: '商品详情',
      permission: true,
      deepth: 2
    },
  },
  {
    path: '/commdsBrand',
    name: 'CommdsBrand',
    component: () =>
            import(/* webpackChunkName: "commodity" */ '@/views/goodsManage/commodity/subPage/commdsBrand.vue'),
    meta: {
      title: '品牌',
      deepth: 3
    },
  },
  {
    path: '/addClass',
    name: 'addClass',
    component: () =>
            import(/* webpackChunkName: "commodity" */ '@/views/goodsManage/commodity/subPage/addClass.vue'),
    meta: {
      title: '商品分类',
      deepth: 3
    },
  },
  {
    path: '/commdsTig',
    name: 'CommdsTig',
    component: () =>
            import(/* webpackChunkName: "commodity" */ '@/views/goodsManage/commodity/subPage/commdsTig.vue'),
    meta: {
      title: '标签',
      deepth: 3
    },
  },
  {
    path: '/addLabel',
    name: 'AddLabel',
    component: () =>
            import(/* webpackChunkName: "commodity" */ '@/views/goodsManage/commodity/template/AddLabel.vue'),
    meta: {
      title: '新增标签',
      deepth: 3
    },
  },
  {
    path: '/addBrand',
    name: 'AddBrand',
    component: () =>
            import(/* webpackChunkName: "commodity" */ '@/views/goodsManage/commodity/template/AddBrand.vue'),
    meta: {
      title: '新增品牌',
      deepth: 3
    },
  },
  {
    path: '/coomdsPrice',
    name: 'CoomdsPrice',
    component: () =>
            import(/* webpackChunkName: "commodity" */ '@/views/goodsManage/commodity/subPage/coomdsPrice.vue'),
    meta: {
      title: '按客户级别定价',
      deepth: 4
    },
  },
  {
    path: '/coomdsPrices',
    name: 'CoomdsPrices',
    component: () =>
            import(/* webpackChunkName: "commodity" */ '@/views/goodsManage/commodity/subPage/coomdsPrices.vue'),
    meta: {
      title: '按客户定价',
      deepth: 4
    },
  },
  // 页面废弃
  {
    path: '/coomdsPackage',
    name: 'CoomdsPackage',
    component: () =>
            import(/* webpackChunkName: "commodity" */ '@/views/goodsManage/commodity/subPage/coomdsPackage.vue'),
    meta: {
      title: '套餐信息',
      deepth: 3
    },
  },
  {
    path: '/searchCooms',
    name: 'SearchCooms',
    component: () =>
            import(/* webpackChunkName: "commodity" */ '@/views/goodsManage/commodity/SearchCooms.vue'),
    meta: {
      title: '商品搜索结果',
      deepth: 1
    },
  },
  {
    path: '/clientDetail',
    name: 'ClientDetail',
    component: () =>
            import(/* webpackChunkName: "commodity" */ '@/views/customerManage/clientDetail.vue'),
    meta: {
      title: '客户详情',
      // keepAlive: true,
      deepth: 2,
      permission: true
    },
  },
]

export default commodityRouter
